import { all, takeEvery } from 'redux-saga/effects';
import { ACTIONS } from '../types';
import { setClosestConfirmationSlotSaga } from './setClosestConfirmationSlotSaga';

export function* betConfirmationRootSaga() {
  yield all([takeEvery(ACTIONS.SET_CLOSEST_CONFIRMATION_SLOT, setClosestConfirmationSlotSaga)]);
}
